import React from "react";
import { Box, Typography } from "@mui/material";
import { InviteListItem } from "./invite-list-item";

export const SuccessfulInviteList = ({ invites, currentPage = 1, pageSize = 20 }) => {
    return (
        <Box sx={{ mt: 4 }}>
            <Typography
                fontWeight="bold"
                gutterBottom
                sx={{
                    textAlign: { xs: "center", sm: "left" },
                    fontSize: { xs: "1rem", sm: "1.25rem" },
                    px: { xs: 2, md: 4 },
                }}
            >
                دعوت شدگان موفق
            </Typography>
            
            <Box sx={{ mt: 2 }}>
                {invites.map((invite, index) => {
                    // Calculate correct continuous index (1-based)
                    const displayIndex = (currentPage - 1) * pageSize + index + 1;
                    
                    return (
                        <InviteListItem
                            key={invite.id}
                            index={displayIndex}
                            phone={invite.username}
                            date={invite.date_joined}
                        />
                    );
                })}
            </Box>
        </Box>
    );
};